export const ACL = {
    ACTIVITY: {
        VIEW: 'MB_00572'
    },
    ACCOUNTABLE: {
        VIEW: 'MB_00630'
    },
};